import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelpSidenavService {
  private readonly _showHelpSidenav = signal(false);

  readonly showHelpSidenav = this._showHelpSidenav.asReadonly();

  toggle() {
    this._showHelpSidenav.set(!this._showHelpSidenav());
  }

  close() {
    this._showHelpSidenav.set(false);
  }

  open() {
    this._showHelpSidenav.set(true);
  }
}
